import { useState, useEffect } from "react";
import styles from "./shared.module.css"

import { useSelector } from "react-redux";
import { isPathGranted, SUBADMIN_ROLE } from "config/dashboardPages";

const AccessController = ({ roles, modules, children }) => {
  const { loading, user } = useSelector((state) => state.user);

  if (!user?.module || !user?.role)
    return (
      <div className="">
        You do not have sufficient permissions to view this page.
      </div>
    );

  if (!modules.includes(user.module) || !roles.includes(user.role)) {
    return (
      <div className="">
        You do not have sufficient permissions to view this page.
      </div>
    );
  }

  return <> {children} </>;
};

const AccessController2 = ({ roles, children }) => {
  const { loading, user } = useSelector((state) => state.user);

  const handleReturnToHome = () => {
    window.location.href = "/";
  };

  const handleReturnToLogin = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  const PermissionDenied = () => (
    <div className={styles.container}>
      <p>You do not have sufficient permissions to view this page.</p>
      <div className={styles.buttonRow}>
        <button className={styles.button} onClick={handleReturnToHome}>
          Return to Home Page
        </button>
        <button className={styles.buttonOutline} onClick={handleReturnToLogin}>
          Return to Login Page
        </button>
      </div>
    </div>
  );

  if (!user?.role) return <PermissionDenied />;

  // Sub-admins are gated by their granted-page permission matrix, not by role.
  if (user.role === SUBADMIN_ROLE) {
    if (isPathGranted(window.location.pathname, user.permissions)) {
      return <> {children} </>;
    }
    return <PermissionDenied />;
  }

  if (!roles.includes(user.role)) return <PermissionDenied />;

  return <> {children} </>;
};

export default AccessController2;
